import { Component } from '@angular/core';

@Component({
  selector: 'app-configuration-management-list',
  templateUrl: './configuration.management.list.component.html'
})
export class ConfigurationManagementListComponent {
  
}